import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.index-of.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.number.constructor.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.concat.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.array.includes.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.string.includes.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.object.to-string.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.constructor.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.all.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.catch.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.race.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.reject.js";
import "../../../../../core-js@3.37.1/node_modules/core-js/modules/es.promise.resolve.js";
import n from "../../../../../@mx_fsp-mweb-env@0.125.0/node_modules/@mx/fsp-mweb-env/dist/index.esm.js";
function h(e) {
  KNB.ready(function () {
    KNB.setLLButton(e);
  });
}
function K() {
  KNB.ready && KNB.ready(function () {
    KNB.setNavigationBarHidden({
      flag: 1
    });
  });
}
function x(e, i) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0,
    a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
  if (n.isInBoc && !e.includes("http")) {
    m("actionOpenApp", {
      appUrl: e
    }, function () {}, function () {
      i && i();
    });
    return;
  }
  if (KNB.env.isTitans || n.isHarmony) KNB.ready(function () {
    KNB.openPage({
      url: e,
      query: {
        _knbopeninapp: 1,
        notitlebar: t
      },
      fail: i
    });
  });else if (n.appName === "WXAPP_MT") {
    var o = encodeURIComponent(e),
      r = "/index/pages/h5/h5?weburl=".concat(o, "&f_openId=1&f_wxUserInfo=1&f_token=1&f_pos=1&f_finger=1&f_openIdCipher=1&title=").concat(a);
    n.layerType === "wallet" ? window.parent.postMessage({
      type: "wx.miniProgram",
      method: "navigateTo",
      params: {
        url: r
      }
    }, "*") : window.wx.miniProgram.navigateTo({
      url: r
    });
  } else if (n.appName === "WXAPP_WM") {
    var s = encodeURIComponent(e),
      p = "/pages/web-view/web-view?type=DIRECT&wxapp_force_login=1&wxapp_h5_payment=1&wxapp_force_loc=1&webviewUrl=".concat(s);
    n.layerType === "wallet" ? window.parent.postMessage({
      type: "wx.miniProgram",
      method: "navigateTo",
      params: {
        url: p
      }
    }, "*") : window.wx.miniProgram.navigateTo({
      url: p
    });
  } else location.href = e;
}
function T() {
  n.isInWXAPP ? window.wx.miniProgram.navigateBack() : n.isEhcModal ? KNB.use("ehc.closeModal", {
    success: function success() {}
  }) : KNB.ready(function () {
    KNB.closePage();
  });
}
function m(e, i, t, a) {
  var o;
  (o = window == null ? void 0 : window.c_plugins) === null || o === void 0 || o.merchantBridge[e](t || function () {}, a || function () {}, i);
}
export { m as bocBridge, T as closePage, K as navBarHidden, x as openPage, h as setLLButton };
